import React from 'react';
import { List, Text } from 'basis';
import { PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE } from '_config';
import { getFeatures } from 'featureToggles';
import { formatNumber } from 'utils/formatNumber';

const FIRST_ANNUAL_FEE_WAIVER_TEXT = 'Your first Annual fee waived upon approval.';
const ANNUAL_FEE_WAIVER_SUFFIX =
  'or more each year on eligible purchases and your Annual fee will be waived the following year.';

const getAnnualFeesByProduct = productCode => {
  const { prestigeRatesAndFees, premiereRatesAndFees } = getFeatures();
  return {
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: prestigeRatesAndFees,
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: premiereRatesAndFees,
  }[productCode];
};

const getAnnualFeeWaiverSpendThreshold = productCode => {
  const fee = getAnnualFeesByProduct(productCode)?.annualFeeWaiverSpendThresholds;
  return fee ? `$${formatNumber(fee)}` : '';
};

const getAnnualFee = productCode => {
  const fee = getAnnualFeesByProduct(productCode)?.annualFee;
  return fee ? `$${formatNumber(fee)}` : '';
};

const getAnnualFeeWaiverText = (productCode, productComparePage) =>
  productComparePage ? (
    <>
      <strong>{getAnnualFee(productCode)}</strong> annual fee waived for the first year upon approval.
    </>
  ) : (
    FIRST_ANNUAL_FEE_WAIVER_TEXT
  );

export const getAnnualFeeWaiverBenefits = (productCode, { productComparePage = false } = {}) => [
  getAnnualFeeWaiverText(productCode, productComparePage),
  `Spend ${getAnnualFeeWaiverSpendThreshold(productCode)} ${ANNUAL_FEE_WAIVER_SUFFIX}`,
];

export const getAnnualFeeWaiverListItems = ({ productCode }) => [
  <List.Item key="first-annual-fee-waiver">
    <Text>
      <strong>{FIRST_ANNUAL_FEE_WAIVER_TEXT}</strong>
    </Text>
  </List.Item>,
  <List.Item key="annual-fee-waiver-spend-threshold">
    <Text>
      <strong>Spend {getAnnualFeeWaiverSpendThreshold(productCode)} </strong>
      {ANNUAL_FEE_WAIVER_SUFFIX}
    </Text>
  </List.Item>,
];
